exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".auth-spiner-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center; }\n  .auth-spiner-container.whatsapp {\n    background: url(" + require("../../../assets/whatsapp_bg.png") + ") round 0 0 fixed; }\n  .auth-spiner-container.viber {\n    background: url(" + require("../../../assets/viber_bg.png") + ") round 0 0 fixed; }\n  .auth-spiner-container.telegram {\n    background: url(" + require("../../../assets/telegram_bg.png") + ") round 0 0 fixed; }\n  .auth-spiner-container.facebook {\n    background: white round 0 0 fixed; }\n  .auth-spiner-container .fa {\n    font-size: 40pt;\n    color: white; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/RegistrationAuthorization/Spiner/Spiner.scss
// module id = 239
// module chunks = 0